import React from 'react'

export const EnvelopeMoonpig: React.FC<
  React.HTMLAttributes<HTMLOrSVGElement>
> = props => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="envelope envelope-top"
        d="M0 37.1962L42.646 1.1105C44.3959 -0.370165 46.9601 -0.370165 48.7099 1.1105L91.3559 37.1962L45.6775 70.5759L0 37.1962Z"
        fill="#BABABA"
      />
      <g className="card" filter="url(#card-shadow)">
        <path d="M9.36987 22.6155C9.36987 19.2419 12.1048 16.507 15.4785 16.507H74.7063C78.08 16.507 80.8149 19.2419 80.8149 22.6155V73.8973H9.36987V22.6155Z" />
      </g>
      <g className="pin" origin="center" fill="#34519f">
        <path d="M24.4529 37.5405L24.549 39.9913C24.5603 40.2792 24.3299 40.5188 24.0418 40.5188H22.5675C22.2755 40.5188 22.0437 40.2731 22.0607 39.9816L22.2046 37.5113L19.969 39.3338C19.7306 39.5282 19.3755 39.4675 19.2151 39.2051L18.5083 38.0484C18.3583 37.8029 18.4421 37.4819 18.693 37.3411L21.0951 35.993L18.5114 34.9449C18.2361 34.8332 18.1151 34.5101 18.2494 34.2451L18.9055 32.9497C19.0337 32.6966 19.3444 32.5977 19.5953 32.7301L22.2922 34.1535L22.1708 31.5311C22.1574 31.2418 22.3883 31 22.6779 31H24.2033C24.4966 31 24.7288 31.2478 24.7099 31.5405L24.5405 34.1535L26.8741 32.3112C27.1098 32.1251 27.4547 32.1832 27.6164 32.4363L28.3679 33.6125C28.5251 33.8585 28.4429 34.1861 28.1881 34.3287L25.7377 35.701L28.4114 36.8539C28.685 36.9719 28.7986 37.2989 28.6572 37.5611L27.9635 38.847C27.8306 39.0932 27.5236 39.1855 27.277 39.0534L24.4529 37.5405Z" />
        <path d="M39.1459 37.5405L39.242 39.9913C39.2533 40.2792 39.0229 40.5188 38.7348 40.5188H37.2605C36.9685 40.5188 36.7367 40.2731 36.7537 39.9816L36.8976 37.5113L34.662 39.3338C34.4236 39.5282 34.0685 39.4675 33.9081 39.2051L33.2013 38.0484C33.0513 37.8029 33.1351 37.4819 33.386 37.3411L35.7881 35.993L33.2044 34.9449C32.9291 34.8332 32.8081 34.5101 32.9423 34.2451L33.5985 32.9497C33.7267 32.6966 34.0374 32.5977 34.2883 32.7301L36.9852 34.1535L36.8638 31.5311C36.8504 31.2418 37.0813 31 37.3709 31H38.8963C39.1896 31 39.4218 31.2478 39.4029 31.5405L39.2335 34.1535L41.5671 32.3112C41.8028 32.1251 42.1477 32.1832 42.3094 32.4363L43.0609 33.6125C43.2181 33.8585 43.1358 34.1861 42.8811 34.3287L40.4306 35.701L43.1044 36.8539C43.378 36.9719 43.4916 37.2989 43.3502 37.5611L42.6565 38.847C42.5236 39.0932 42.2166 39.1855 41.97 39.0534L39.1459 37.5405Z" />
        <path d="M53.8394 37.5405L53.9355 39.9913C53.9468 40.2792 53.7164 40.5188 53.4283 40.5188H51.9539C51.662 40.5188 51.4302 40.2731 51.4472 39.9816L51.5911 37.5113L49.3555 39.3338C49.1171 39.5282 48.762 39.4675 48.6016 39.2051L47.8948 38.0484C47.7447 37.8029 47.8286 37.4819 48.0795 37.3411L50.4815 35.993L47.8979 34.9449C47.6226 34.8332 47.5016 34.5101 47.6358 34.2451L48.292 32.9497C48.4202 32.6966 48.7309 32.5977 48.9818 32.7301L51.6787 34.1535L51.5573 31.5311C51.5439 31.2418 51.7748 31 52.0644 31H53.5898C53.8831 31 54.1153 31.2478 54.0963 31.5405L53.927 34.1535L56.2606 32.3112C56.4963 32.1251 56.8412 32.1832 57.0029 32.4363L57.7544 33.6125C57.9115 33.8585 57.8293 34.1861 57.5746 34.3287L55.1241 35.701L57.7979 36.8539C58.0714 36.9719 58.1851 37.2989 58.0437 37.5611L57.35 38.847C57.2171 39.0932 56.9101 39.1855 56.6635 39.0534L53.8394 37.5405Z" />
        <path d="M68.5326 37.5405L68.6287 39.9913C68.64 40.2792 68.4097 40.5188 68.1215 40.5188H66.6472C66.3552 40.5188 66.1234 40.2731 66.1404 39.9816L66.2843 37.5113L64.0487 39.3338C63.8103 39.5282 63.4552 39.4675 63.2948 39.2051L62.588 38.0484C62.438 37.8029 62.5218 37.4819 62.7727 37.3411L65.1748 35.993L62.5911 34.9449C62.3158 34.8332 62.1948 34.5101 62.3291 34.2451L62.9852 32.9497C63.1134 32.6966 63.4241 32.5977 63.675 32.7301L66.3719 34.1535L66.2505 31.5311C66.2371 31.2418 66.468 31 66.7576 31H68.283C68.5763 31 68.8086 31.2478 68.7896 31.5405L68.6202 34.1535L70.9538 32.3112C71.1895 32.1251 71.5344 32.1832 71.6961 32.4363L72.4476 33.6125C72.6048 33.8585 72.5226 34.1861 72.2679 34.3287L69.8174 35.701L72.4911 36.8539C72.7647 36.9719 72.8783 37.2989 72.7369 37.5611L72.0432 38.847C71.9104 39.0932 71.6033 39.1855 71.3567 39.0534L68.5326 37.5405Z" />
      </g>
      <path
        className="envelope envelope-sides"
        d="M0 85.2075V37.1954L45.678 70.5755L91.3559 37.1954V85.2075C91.3559 87.7995 89.2546 89.9008 86.6626 89.9008H4.69328C2.10125 89.9008 0 87.7995 0 85.2075Z"
        fill="#D1D1D1"
      />
      <path
        className="envelope envelope-bottom"
        d="M43.0453 54.7961C44.6344 53.7164 46.722 53.7164 48.3112 54.7961L89.708 88.7813C88.8901 89.4786 87.8304 89.901 86.6713 89.901H4.68522C3.52576 89.901 2.46539 89.479 1.64734 88.7813L43.0453 54.7961Z"
        fill="#E8E8E8"
      />
      <defs>
        <filter
          id="card-shadow"
          x="6.86987"
          y="13.557"
          width="76.4451"
          height="62.3903"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.45" />
          <feGaussianBlur stdDeviation="1.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0117647 0 0 0 0 0.301961 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11352_1301"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11352_1301"
            result="shape"
          />
        </filter>
        <filter
          xmlns="http://www.w3.org/2000/svg"
          id="mail-icon-shadow"
          x="60"
          y="59"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0117647 0 0 0 0 0.301961 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11352_1301"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11352_1301"
            result="shape"
          />
        </filter>
        <clipPath id="provider-clip">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(73 69)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
